import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
`
const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

class StatusBar extends Component {
  constructor(props) {
    super(props)
    this.state = {};
  }

  render() {
    const { text } = this.props;
    return (
      <Container>
        <Text>{`- ${text}`}</Text>
      </Container>
    );
  }
}

StatusBar.propTypes = {
  value: PropTypes.bool,
  text: PropTypes.string,
}

StatusBar.defaultProps = {

}

export default StatusBar;
